export default __webpack_public_path__ + "static/media/care-3.73eebf97.jpg";